import { graphql, useStaticQuery } from 'gatsby';

interface Address {
	streetAddress: string;
	addressLocality: string;
	postalCode: string;
	addressCountry: string;
}

interface ContactPoint {
	telephone: string;
	email: string;
}

interface Organization {
	name: string;
	legalName: string;
	url: string;
	address: Address;
	contactPoint: ContactPoint;
}

interface SiteMetadata {
	title: string;
	siteUrl: string;
	linkedInUrl: string;
	xingUrl: string;
	organization: Organization;
}

interface Site {
	siteMetadata: SiteMetadata;
}

interface QueryResult {
	site: Site;
}

export const useSiteMetadata = (): SiteMetadata => {
	const {
		site: { siteMetadata },
	} = useStaticQuery<QueryResult>(graphql`
		query {
			site {
				siteMetadata {
					title
					siteUrl
					linkedInUrl
					xingUrl
					organization {
						name
						legalName
						url
						address {
							streetAddress
							addressLocality
							postalCode
							addressCountry
						}
						contactPoint {
							telephone
							email
						}
					}
				}
			}
		}
	`);

	return siteMetadata;
};
